import type { ClientPaths } from "newui/utils/navigation/ClientPaths";
import type { RfxListItemResource } from "../../types/rfx-list.type";

/**
 * Server-authoritative Panel row target. `RfxListItemResource.rfx_evaluation_id`
 * is the only per-row signal the wire actually carries (`RfxAccessFlags` is
 * fetched by the destination page itself — evaluation/preview — not attached
 * to list rows, per reviews/task-011.review.md). A present id means the
 * server resolved an active evaluation for this row; null means read-only —
 * so this NEVER falls back to `/evaluation/null`.
 */
export const getPanelRowTarget = (
	clientPaths: Pick<ClientPaths, "viewEvaluation" | "viewRfxPreview">,
	row: Pick<RfxListItemResource, "rfx_id" | "rfx_evaluation_id" | "uuid">
): string =>
	row.rfx_evaluation_id !== null && row.rfx_evaluation_id !== undefined
		? clientPaths.viewEvaluation(row.rfx_id, row.rfx_evaluation_id)
		: clientPaths.viewRfxPreview(row.uuid);
